import React from "react";
import { Chip } from "@material-ui/core";

const statusColors = {
  awaitingPayment: {
    background: "#fff4d6",
    color: "#8a5a00",
  },
  partiallyPaid: {
    background: "#e8f0ff",
    color: "#1d4f91",
  },
  awaitingCoordination: {
    background: "#efe7ff",
    color: "#5a32a3",
  },
  awaitingFulfillment: {
    background: "#e6f7ee",
    color: "#17633a",
  },
  readyForDeliver: {
    background: "#dcfce7",
    color: "#166534",
  },
  awaitingShipment: {
    background: "#e5f6fb",
    color: "#0d6474",
  },
  shipped: {
    background: "#eef2f7",
    color: "#334155",
  },
  completed: {
    background: "#dff7e8",
    color: "#116329",
  },
  refunding: {
    background: "#fff0e5",
    color: "#9a4b00",
  },
  cancelled: {
    background: "#ffe7e7",
    color: "#9f1f1f",
  },
};

export default function OrderStatusBadge({ status, initials }) {
  const label =
    initials?.enums?.orderStatus?.find((item) => item.value === status)
      ?.title || status;
  const colors = statusColors[status] || {
    background: "#eef2f7",
    color: "#334155",
  };

  return (
    <Chip
      size="small"
      label={label}
      style={{
        minWidth: 92,
        fontWeight: 600,
        backgroundColor: colors.background,
        color: colors.color,
      }}
    />
  );
}
